(function (Rayban, $) {
  'use strict';

  var VERSION = '1.0',
    overlaysInstances = [],
    defaultSettings = {
      centerVertically: false,
      cssClass: 'rb-overlay',
      closeButtonClass: 'rb-overlay-close-trigger',
      triggerCssClass: 'rb-overlay-trigger',
      bodyClassName: 'rb-overlay-open',
      contentDivClassName: 'rb-overlay-content'
    };

  var addCSSClass = function (el, cssClass) {
    if (el) {
      el.className += ' ' + cssClass;
    }
  };

  var removeCSSClass = function (el, cssClass) {
    if (el) {
      el.className = el.className.replace(cssClass, '');
    }
  };

  var Overlay = function(trigger, settings) {
    if (settings) {
      this.settings = Rayban.utilities.extend(this.settings, settings);
    }
    this.trigger = trigger;
    this.overlayId = this.trigger.getAttribute('href');
    this.overlayDiv = document.querySelector(this.overlayId);

    if (this.overlayDiv) {
      this.innerDiv = this.overlayDiv.querySelector('div');
      this.closeTrigger = this.overlayDiv.querySelector('.' + this.settings.closeButtonClass);
      this.bindActions();
    } else {
      console.debug('no overlay found for ' + this.trigger.getAttribute('href'));
    }
  };

  Overlay.prototype = {
    version: VERSION,
    trigger: null,
    closeTrigger: null,
    overlayId: null,
    overlayDiv: null,
    innerDiv: null,
    settings: defaultSettings,

    bindActions: function () {
      var self = this;

      this.overlayDiv.addEventListener('click', function (e) {
        if (e.target === self.overlayDiv) {
          self.close();
        }

      }, false);

      document.addEventListener('keydown', function(e) {
        if ( e.keyCode === 27 ) { // ESC
          self.closeAll();
        }
      }, false);

      if (self.closeTrigger) {
        self.closeTrigger.addEventListener('click', function (e) {
          e.preventDefault();
          self.close();
        }, false);
      } else {
        console.debug('not close link set.');
      }

      // this.innerDiv.addEventListener('click', function (e) {
      //   e.stopPropagation();
      // }, false);

    },

    toggle: function () {
      console.debug('TODO');
    },

    scrollTop: function () {
      // XXX: I'm using jquery scroll behavior will be supported
      // until http://caniuse.com/#search=Scroll-behavior
      $(this.overlayDiv).animate({ scrollTop: 0 }, 200);
    },

    open: function () {
      var self = this;
      this.closeAll();
      this.scrollTop();
      addCSSClass(this.overlayDiv, 'active');
      addCSSClass(document.querySelector('body'), this.settings.bodyClassName);
      if (self.settings.centerVertically) {
        this.updateAlignment();
        $(window).on('resize.rb-overlay', function() {
          self.updateAlignment();
        });
      }
    },

    close: function () {
      removeCSSClass(document.querySelector('body'), this.settings.bodyClassName);
      removeCSSClass(this.overlayDiv, 'active');
      $(window).off('resize.rb-overlay');
    },

    closeAll: function () {
      for (var i=0; i < overlaysInstances.length; i+=1) {
        overlaysInstances[i].close();
      }
    },
    
    updateAlignment: function () {
      var windowH = $(window).height();
      var overlayH = $(this.innerDiv).outerHeight(true);
      var doesOverflow = windowH < overlayH;
      $(this.overlayDiv).toggleClass('rb-overlay--align-vertical', !doesOverflow);
    }, 

    setContent: function (html, callback) {
      this.innerDiv.querySelector('.' + this.settings.contentDivClassName).innerHTML = html;
      if (typeof callback === 'function') {
        callback();
      }
    }

  };

  var OverlayManager = function (settings) {
    if (settings) {
      this.settings = Rayban.utilities.extend(this.settings, settings);
    }
  };

  OverlayManager.prototype = {
    settings: defaultSettings,

    initAll: function () {
      var triggers = document.querySelectorAll('.' + this.settings.triggerCssClass);
      for (var i = 0; i < triggers.length; i += 1) {
        var el = triggers[i];
        if (! el.RBOverlay) {
          this.setupOverlay(triggers[i]);
        }
      }
    },

    setupOverlay: function (trigger, skipEventListener) {
      if (trigger.RBOverlay) {
        console.debug('overay already set.');
      } else {
        var overlay = new Overlay(trigger, this.settings);
        overlaysInstances.push(overlay);
        trigger.RBOverlay = overlay;
        if (! skipEventListener) {
          trigger.addEventListener('click', function (e) {
            var el = this;
            e.preventDefault();
            el.RBOverlay.open();
            if($(el).attr('href') === '#wcs-afterpay-overlay') {
              triggerVueMethod('showAfterpayModal');
            } else if ($(el).attr('href') === '#wcs-klarna-afterpay-overlay') {
              triggerVueMethod('showKlarnaAfterpayModal');
            }
          }, false);
        }
      }

      return overlay;
    }

  };

  Rayban.utilities.extend(Rayban, {
    Overlay: Overlay,
    OverlayManager: OverlayManager
  });

})(
  window.Rayban = window.Rayban || {},
  window.jQuery
);
